import { Box } from "@nulogy/components";
import FormButtons from "components/controls/FormButtons";
import Input from "components/controls/Input";
import SettingsForm from "components/controls/SettingsForm";
import PageWithBreadcrumbs from "components/pages/PageWithBreadcrumbs";
import SiteIndexView from "components/pages/site/SiteIndexView";
import UserIndexView from "components/pages/user/UserIndexView";
import React from "react";

export default function CompanyEditView({
  company,
  onSave,
  onCancel,
  onDelete,
  canCreateSite,
  canCreateUser,
  canUpdateCompany,
  createSitePath,
  createUserPath,
}) {
  const { id, name, sites, users } = company;
  const title = id ? `Update company - ${name}` : "Create company";

  return (
    <PageWithBreadcrumbs
      className="companyEditView spec-company-form"
      extraBreadcrumbs={[{ label: "Companies", path: "/companies" }]}
      title={title}
    >
      <SettingsForm initialValues={company} onSave={onSave}>
        <Input field="name" labelText="Name" />
        <FormButtons
          deleteConfirmationMessage="Are you sure you want to delete this company? This action is irreversible."
          onCancel={onCancel}
          onDelete={id ? onDelete : null}
        />
      </SettingsForm>

      {id && (
        <>
          <hr />
          <Box pt="x2">
            <SiteIndexView
              assignedSites={sites}
              canCreateSite={canCreateSite}
              canUpdateCompany={canUpdateCompany}
              createSitePath={createSitePath}
              simpleView
            />
          </Box>
          <hr />
          <Box pt="x2">
            <UserIndexView
              canCreateUser={canCreateUser}
              canUpdateCompany={canUpdateCompany}
              createUserPath={createUserPath}
              simpleView
              users={users}
            />
          </Box>
        </>
      )}
    </PageWithBreadcrumbs>
  );
}
